import { computed } from "vue";
import { useRoute } from "vue-router";
export default {
  name: "ProductDetails",
  setup: function setup() {
    var route = useRoute(); //接收productList传递过来的query参数

    var productTitle = computed(function () {
      return route.query.title;
    });
    var productDetail = computed(function () {
      return JSON.parse(route.query.detail);
    });
    return {
      productTitle: productTitle,
      productDetail: productDetail
    };
  }
};